export const typography = {
    d1: {
        fontSize: 96,
        fontWeight: 300,
        lineHeight: '112px',
        letterSpacing: '-1.5px',
    },
    d2: {
        fontSize: 60,
        fontWeight: 300,
        lineHeight: '72px',
        letterSpacing: '-0.5px',
    },
    d3: {
        fontSize: 48,
        fontWeight: 400,
        lineHeight: '56px',
        letterSpacing: 0,
    },
    h1: {
        fontSize: 36,
        fontWeight: 400,
        lineHeight: '44px',
        letterSpacing: '0.5px',
        ['@media (max-width:1199px)']: {
            fontSize: 28,
            fontWeight: 400,
            lineHeight: '36px',
            letterSpacing: '0px',
        },
        ['@media (max-width:899px)']: {
            fontSize: 24,
            fontWeight: 400,
            lineHeight: '32px',
            letterSpacing: '0px',
        },
    },
    h2: {
        fontSize: 32,
        fontWeight: 400,
        lineHeight: '40px',
        letterSpacing: '0.5px',
        ['@media (max-width:1199px)']: {
            fontSize: 26,
            fontWeight: 400,
            lineHeight: '34px',
            letterSpacing: '0px',
        },
        ['@media (max-width:899px)']: {
            fontSize: 20,
            fontWeight: 500,
            lineHeight: '28px',
            letterSpacing: '0.15px',
        },
    },
    h3: {
        fontSize: 28,
        fontWeight: 400,
        lineHeight: '36px',
        ['@media (max-width:1199px)']: {
            fontSize: 24,
            fontWeight: 400,
            lineHeight: '32px',
            letterSpacing: '0px',
        },
        ['@media (max-width:899px)']: {
            fontSize: 20,
            fontWeight: 500,
            lineHeight: '28px',
            letterSpacing: '0.15px',
        },
    },
    h4: {
        fontSize: 26,
        fontWeight: 400,
        lineHeight: '34px',
        letterSpacing: '0px',
        ['@media (max-width:1199px)']: {
            fontSize: 20,
            fontWeight: 500,
            lineHeight: '28px',
            letterSpacing: '0.15px',
        },
        ['@media (max-width:899px)']: {
            fontSize: 20,
            fontWeight: 500,
            lineHeight: '28px',
            letterSpacing: '0.15px',
        },
    },
    h5: {
        fontSize: 24,
        fontWeight: 400,
        lineHeight: '32px',
        ['@media (max-width:1199px)']: {
            fontSize: 20,
            fontWeight: 500,
            lineHeight: '28px',
            letterSpacing: '0.15px',
        },
        ['@media (max-width:899px)']: {
            fontSize: 20,
            fontWeight: 500,
            lineHeight: '28px',
            letterSpacing: '0.15px',
        },
    },
    h6: {
        fontSize: 20,
        fontWeight: 500,
        lineHeight: '28px',
        letterSpacing: '0.15px',
        ['@media (max-width:1199px)']: {
            fontSize: 20,
            fontWeight: 500,
            lineHeight: '28px',
            letterSpacing: '0.15px',
        },
        ['@media (max-width:899px)']: {
            fontSize: 20,
            fontWeight: 500,
            lineHeight: '28px',
            letterSpacing: '0.15px',
        },
    },
    subtitle1: {
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '24px',
        letterSpacing: '0.15px',
    },
    subtitle2: {
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '20px',
        letterSpacing: '0.1px',
    },
    body1: {
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '24px',
        letterSpacing: '0.15px',
    },
    body2: {
        fontSize: 14,
        fontWeight: 400,
        lineHeight: '20px',
        letterSpacing: '0.15px',
    },
    caption: {
        fontSize: 12,
        fontWeight: 400,
        lineHeight: '14px',
        letterSpacing: '0.4px',
    },
    overline: {
        fontSize: 12,
        fontWeight: 400,
        lineHeight: '14px',
        letterSpacing: '1px',
    },
};
